<template>
	<div
		:class="[
			'text-gray-700 focus-within:text-orange-500',
			markInvalid ? 'text-red-500' : '',
		]"
	>
		<div class="flex justify-between flex-wrap gap-x-2">
			<label class="block font-medium" :for="inputId">{{ __(label) }}</label>
			<span class="text-red-500" v-if="markInvalid">{{
				validationMessage
			}}</span>

			<!-- replace markInvalid!! -->
			<span class="text-gray-500" v-else-if="!required && !markInvalid"
				>optional</span
			>
		</div>
		<div class="mt-1 relative">
			<ui-month-input
				v-model="val"
				:minDate="minDate"
				:maxDate="maxDate"
				:markInvalid="markInputInvalid"
				:verticalAlignment="verticalAlignment"
			/>
		</div>
	</div>
</template>

<script>
import UiInputGroup from "./InputGroup.vue";
export default {
	mixins: [UiInputGroup],
	props: {
		minDate: {
			type: String,
			default() {
				let today = new Date();
				return today.toISOString().substr(0, 8) + "01";
			},
		},
		maxDate: {
			type: String,
			default: "9999-00-01",
		},
		verticalAlignment: {
			type: String,
			default: "top",
		},
	},
	computed: {
		monthLabels() {
			return this.$cropOptions.monthLabelsEn; // TODO i18n
		},
	},
};
</script>
